import Grid from "@components/Grid/Grid";
import Columns from "./Columns";

export interface Sublayout7025Props {
  content: {
    columns: any;
    backgroundColour?: string;
  };
}

const Sublayout7025 = (props: any) => {
  const { columns, backgroundColour } = props;

  return (
    <div
      className={`sublayout outer-wrap ${
        backgroundColour ? backgroundColour : ""
      }`}
    >
      <div className="wrapper">
        <Grid row justify="space-between">
          <Columns columns={columns} columnTotal={2} customSize={[8, 3]} />
        </Grid>
      </div>
    </div>
  );
};

export default Sublayout7025;
